import mutations from './mutations';
import api from '../api';

export default {
  namespaced: true,
  state: {
    loading: false
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    }
  },
  actions: {
    getAll({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.profile
        .getAll(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          console.log(error);
          return error;
        });
    },
    getPosition({ commit }) {
      commit(mutations.LOADING);
      return api.profile
        .getPosition()
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          console.log(error);
          return error;
        });
    },
    getPermission({ commit }) {
      commit(mutations.LOADING);
      return api.profile
        .getPermission()
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          console.log(error);
          return error;
        });
    },
    detail({ commit }, id) {
      commit(mutations.LOADING);
      return api.profile
        .detail(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          console.log(error);
          return error;
        });
    },
    create({ commit }, payload) {
      commit(mutations.LOADING);
      return api.profile
        .create(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    update({ commit }, { id, params }) {
      commit(mutations.LOADING);
      return api.profile
        .update(id, params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          console.log('error', err);
          commit(mutations.LOADED);
          return err;
        });
    }
  }
};
